import React, {Fragment} from 'react';
import {isNullOrUndefined} from '../utils';
import PropTypes from 'prop-types';

/* This component was created to wrap around braces or other symbols other components.
 * Elements should be passed as children.
 * The motivation for creating this component was due to code repetition on the Ares/FIT application. */

function WrapComponentAroundBraces({children, prefix, braceStart, braceEnd, suffix}) {
	return (
		<Fragment>
			{!isNullOrUndefined(prefix) && prefix}
			{!isNullOrUndefined(braceStart) && braceStart}
			{!isNullOrUndefined(children) && children}
			{!isNullOrUndefined(braceEnd) && braceEnd}
			{!isNullOrUndefined(suffix) && suffix}
		</Fragment>
	);
}

WrapComponentAroundBraces.propTypes = {
	prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node, PropTypes.element]),
	braceStart: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node, PropTypes.element]),
	braceEnd: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node, PropTypes.element]),
	suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node, PropTypes.element])
};

WrapComponentAroundBraces.defaultProps = {
	braceStart: '(',
	braceEnd: ')'
};

export default WrapComponentAroundBraces;
